import { render, staticRenderFns } from "./variables_send.vue?vue&type=template&id=104b2c12&scoped=true"
import script from "./variables_send.vue?vue&type=script&lang=js"
export * from "./variables_send.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104b2c12",
  null
  
)

export default component.exports